import { render, staticRenderFns } from "./TaxWarrantsList.vue?vue&type=template&id=087ca48e&scoped=true&"
import script from "./TaxWarrantsList.vue?vue&type=script&lang=js&"
export * from "./TaxWarrantsList.vue?vue&type=script&lang=js&"
import style0 from "./TaxWarrantsList.vue?vue&type=style&index=0&id=087ca48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ca48e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
